import {FormGroup, ValidatorFn, Validators} from '@angular/forms';

export interface IRegistrationFormValidatorList{
    [key:string]: ValidatorFn | ValidatorFn[]
}

export const UserRegistrationValidators:IRegistrationFormValidatorList ={
    name:[Validators.required],
    email: [Validators.required, Validators.email],
    password: Validators.compose([Validators.required, Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{8,}$")]),
    terms:[Validators.pattern('true')]

}
export const passwordsMustMatch: (passwordField:string, confirmPasswordField:string)=> ValidatorFn = (passwordField:string, confirmPasswordField:string) =>{
    return (control:FormGroup)=>{
      const password = control?.get(passwordField)?.value?.trim();
      const confirmPassword = control?.get(confirmPasswordField)?.value?.trim();

      if(password?.length > 0 && confirmPassword?.length > 0) {
          return password === confirmPassword
              ? null
              :{
                passwordsMustMatch:true
              }
        }

      return null;
    }

}

export const hasAtListOneItemInArray: () => ValidatorFn = () =>{
    return (control:FormGroup)=>{
      return Array.isArray(control?.value) && control.value?.length > 0
            ? null
            :{
                hasAtListOneItemInArray:true
            }
    }

}